import React from 'react'

export const Verbatim: React.FC = ({ children }) => {
  return <pre className="whitespace-pre-wrap">{children}</pre>
}
